<template>
  <div>
    <h4
      v-if="is_running_test && evaluatee_view && !finished_test"
      class="only-impression-student"
    >
      <!-- Mensaje que aparece solo al imprimir -->
      {{
        $t("evaluations.newEvaluations.notAllowedToPrintWhileRunning", {
          entity: $getVisibleNames("evaluations2.test", false, "Instrumento"),
        })
      }}
    </h4>
    <div
      :class="{
        'unselectable-text':
          (user && user.group_names.includes('ESTUDIANTES')) ||
          preview_evaluation,
        'no-print-test': is_running_test && evaluatee_view && !finished_test,
      }"
    >
      <draggable
        v-model="testSegments"
        :disabled="!allows_crud"
        v-bind="dragOptions"
        class="draggable-segment"
        group="segment"
        handle=".handle-segment"
      >
        <transition-group type="transition" name="flip-list">
          <template>
            <div
              class="segment-container"
              :class="{ 'segment-container-min-heigth': allows_crud }"
              v-for="segment in testSegments"
              :key="segment.id"
            >
              <div
                class="title-top-segment"
                v-if="allows_crud || segment.title.trim() != ''"
              >
                <div
                  v-if="allows_crud"
                  class="question-move px-1 handle-segment"
                  :class="{ 'grabbable-cursor': allows_crud }"
                >
                  <b-icon
                    class="move-icon"
                    icon="arrows-expand"
                    scale="1.3"
                  ></b-icon>
                </div>
                <div class="w-100 right-container-segment">
                  <div
                    class="pl-2 w-100 title-segment"
                    :class="{
                      'title-container': allows_crud && !segment.is_locked,
                    }"
                    @click="showModalSegment(segment)"
                  >
                    <RenderVHtml
                      v-b-tooltip.v-secondary.noninteractive.hover="{
                        title: `${
                          allows_crud && !segment.is_locked
                            ? $t('evaluations.newEvaluations.editTitle')
                            : ''
                        }`,
                        boundary: 'viewport',
                      }"
                      :content="segment.title"
                    ></RenderVHtml>
                  </div>
                  <div
                    class="ml-0 title-segment"
                    :class="{
                      'container-buttons-allow-cruds':
                        allows_crud || test.manual_is_valid,
                    }"
                  >
                    <div
                      v-b-tooltip.top.noninteractive.v-secondary="
                        test.manual_is_valid
                          ? $t(
                              'evaluations.newEvaluations.entityUnlockedAndClosed',
                              {
                                entity: $getVisibleNames(
                                  'evaluations2.testsegment',
                                  false,
                                  'Segmento'
                                ),
                              }
                            )
                          : `${$t('evaluations.newEvaluations.lockEntity', {
                              entity: $getVisibleNames(
                                'evaluations2.testsegment',
                                false,
                                'Segmento'
                              ),
                            })}`
                      "
                    >
                      <ButtonMedium
                        v-if="
                          (!segment.is_locked &&
                            allows_crud &&
                            user &&
                            !user.group_names.includes('PROFESORES')) ||
                          (test.manual_is_valid &&
                            !segment.is_locked &&
                            !preview_evaluation &&
                            user &&
                            !user.group_names.includes('PROFESORES'))
                        "
                        :tooltip_text="``"
                        :disabled_button="test.manual_is_valid"
                        :text_button="``"
                        :click_button="() => changeStateSegment(segment)"
                        :icon="'unlock'"
                        :variant="'primary'"
                        :custom_class="`mr-1`"
                      >
                      </ButtonMedium>
                      <!-- <b-button
                        v-if="
                          (!segment.is_locked &&
                            allows_crud &&
                            user &&
                            !user.group_names.includes('PROFESORES')) ||
                          (test.manual_is_valid &&
                            !segment.is_locked &&
                            !preview_evaluation &&
                            user &&
                            !user.group_names.includes('PROFESORES'))
                        "
                        variant="primary"
                        size="sm"
                        class="lock-btn p-1 mr-1 noprint"
                        :disabled="test.manual_is_valid"
                        @click="changeStateSegment(segment)"
                      >
                        <b-icon-unlock-fill></b-icon-unlock-fill>
                      </b-button> -->
                    </div>
                    <div
                      v-b-tooltip.top.noninteractive.v-secondary="
                        test.manual_is_valid
                          ? $t(
                              'evaluations.newEvaluations.entityLockedAndClosed',
                              {
                                entity: $getVisibleNames(
                                  'evaluations2.testsegment',
                                  false,
                                  'Segmento'
                                ),
                              }
                            )
                          : `${$t('evaluations.newEvaluations.unlockEntity', {
                              entity: $getVisibleNames(
                                'evaluations2.testsegment',
                                false,
                                'Segmento'
                              ),
                            })}`
                      "
                    >
                      <ButtonMedium
                        v-if="
                          (segment.is_locked &&
                            allows_crud &&
                            user &&
                            !user.group_names.includes('PROFESORES')) ||
                          (test.manual_is_valid &&
                            segment.is_locked &&
                            !preview_evaluation &&
                            user &&
                            !user.group_names.includes('PROFESORES'))
                        "
                        :tooltip_text="``"
                        :disabled_button="test.manual_is_valid"
                        :text_button="``"
                        :click_button="() => changeStateSegment(segment)"
                        :icon="'lock'"
                        :variant="'primary'"
                        :custom_class="`mr-1`"
                      >
                      </ButtonMedium>
                      <!-- <b-button
                        v-if="
                          (segment.is_locked &&
                            allows_crud &&
                            user &&
                            !user.group_names.includes('PROFESORES')) ||
                          (test.manual_is_valid &&
                            segment.is_locked &&
                            !preview_evaluation &&
                            user &&
                            !user.group_names.includes('PROFESORES'))
                        "
                        variant="primary"
                        size="sm"
                        class="lock-btn p-1 mr-1 noprint"
                        :disabled="test.manual_is_valid"
                        @click="changeStateSegment(segment)"
                      >
                        <b-icon-lock-fill></b-icon-lock-fill>
                      </b-button> -->
                    </div>
                    <ButtonMedium
                      v-if="allows_crud && !segment.is_locked"
                      :tooltip_text="
                        $t('reusable.common.deleteTooltip', {
                          entity: $getVisibleNames(
                            'evaluations2.testsegment',
                            false,
                            'Segmento'
                          ),
                        })
                      "
                      :disabled_button="test.manual_is_valid"
                      :text_button="``"
                      :click_button="() => askForDeleteSegment(segment.id)"
                      :icon="'trash'"
                      :variant="'danger'"
                      :custom_class="`mr-1`"
                    >
                    </ButtonMedium>
                    <!-- <b-button
                      variant="danger"
                      class="delete-btn"
                      v-if="allows_crud && !segment.is_locked"
                      v-b-tooltip.top.noninteractive.v-secondary="
                        `Eliminar ${$getVisibleNames(
                          'evaluations2.testsegment',
                          false,
                          'Segmento'
                        )}`
                      "
                      @click="askForDeleteSegment(segment.id)"
                    >
                      <b-icon-trash></b-icon-trash>
                    </b-button> -->
                  </div>
                </div>
                <ContainerRichTextKlv3
                  :id_modal="`edit-title-segment-modal-${segment.id}-${instrument_id}-${container_instrument_id}`"
                  :title_modal="
                    $t('evaluations.newEvaluations.writeStatementTitle')
                  "
                  :size_modal="`lg`"
                  :object_rich_text="segment"
                  :content_rich_text="segment.title"
                  :show_last_modification="true"
                  @save="(content) => patchSegmentTitle(segment, content)"
                  @close="
                    $bvModal.hide(
                      `edit-title-segment-modal-${segment.id}-${instrument_id}-${container_instrument_id}`
                    )
                  "
                >
                </ContainerRichTextKlv3>
                <!-- <b-modal
                  :id="`edit-title-segment-modal-${segment.id}-${instrument_id}-${container_instrument_id}`"
                  title="Redactar enunciado del título."
                  size="lg"
                  hide-footer
                >
                  <NewRichTextEditor
                    :Object="segment"
                    :Text="segment.title"
                    :hide_title="true"
                    :permit_blank="true"
                    @save="patchSegmentTitle"
                    @close="
                      $bvModal.hide(
                        `edit-title-segment-modal-${segment.id}-${instrument_id}-${container_instrument_id}`
                      )
                    "
                  ></NewRichTextEditor>
                </b-modal> -->
              </div>
              <QuestionsContainer
                :ref="`segment-${segment.id}-${instrument_id}`"
                :container_instrument_id="container_instrument_id"
                :isLoading="is_loading"
                :segment_id="segment.id"
                :segment_order="segment.order"
                :evaluation_criteria_micro_ids="evaluation_criteria_micro_ids"
                :instrument_id="instrument_id"
                :allows_crud="allows_crud && !segment.is_locked"
                :preview_evaluation="preview_evaluation"
                :checked_score="checked_score"
                :checked_weightning="checked_weightning"
                :evaluatee_view="evaluatee_view"
                :evaluator_view="evaluator_view"
                :is_running_test="is_running_test"
                :finished_test="finished_test"
                :user_id="user_id"
                :evaluation_situations="evaluation_situations"
                :closedEvaluationScore="closedEvaluationScore"
                :is_published="is_published"
              ></QuestionsContainer>
            </div>
          </template>
        </transition-group>
      </draggable>
      <div class="container-buttons">
        <ButtonMedium
          v-if="
            allows_crud &&
            test &&
            !test.segment_creation_is_locked &&
            (!evaluationSituation ||
              (evaluationSituation &&
                ![
                  'duoc_ejecucion_practica_test',
                  'duoc_entrega_de_encargo_test',
                  'duoc_presentacion_test',
                ].includes(evaluationSituation.internal_use_id)))
          "
          :tooltip_text="``"
          :text_button="
            $t('reusable.common.createTooltip', {
              entity: $getVisibleNames(
                'evaluations2.testsegment',
                false,
                'Segmento'
              ),
            })
          "
          :click_button="
            () =>
              $bvModal.show(
                `modal-created-segment-${instrument_id}-${container_instrument_id}`
              )
          "
          :icon="'plus'"
          :variant="'primary'"
          :custom_class="``"
        >
        </ButtonMedium>
        <!-- <b-button
        v-if="
          allows_crud &&
          test &&
          !test.segment_creation_is_locked &&
          (!evaluationSituation ||
            (evaluationSituation &&
              ![
                'duoc_ejecucion_practica_test',
                'duoc_entrega_de_encargo_test',
                'duoc_presentacion_test',
              ].includes(evaluationSituation.internal_use_id)))
        "
        variant="info"
        size="sm"
        @click="
          $bvModal.show(
            `modal-created-segment-${instrument_id}-${container_instrument_id}`
          )
        "
      >
        + Crear
        {{ $getVisibleNames("evaluations2.testsegment", false, "Segmento") }}
      </b-button> -->
      </div>
      <ContainerRichTextKlv3
        :id_modal="`modal-created-segment-${instrument_id}-${container_instrument_id}`"
        :title_modal="
          $t('reusable.common.createTooltip', {
            entity: $getVisibleNames(
              'evaluations2.testsegment',
              false,
              'Segmento'
            ),
          })
        "
        :size_modal="`lg`"
        :object_rich_text="{}"
        :content_rich_text="''"
        :show_last_modification="true"
        :allow_list_mode="true"
        @save="(content) => createSegment(content)"
        @save-list="(contents) => createSegments(contents)"
        @close="
          $bvModal.hide(
            `modal-created-segment-${instrument_id}-${container_instrument_id}`
          )
        "
      >
      </ContainerRichTextKlv3>
      <!-- <b-modal
        :id="`modal-created-segment-${instrument_id}-${container_instrument_id}`"
        :title="`Crear ${$getVisibleNames(
          'evaluations2.testsegment',
          false,
          'Segmento'
        )}`"
        hide-footer
        size="lg"
      >
        <NewRichTextEditor
          :Text="''"
          @save="createSegment"
          :hide_title="true"
          :permit_blank="true"
          @close="
            $bvModal.hide(
              `modal-created-segment-${instrument_id}-${container_instrument_id}`
            )
          "
        ></NewRichTextEditor>
      </b-modal> -->
      <QuestionsContainer
        :ref="`segment-null-${instrument_id}`"
        :container_instrument_id="container_instrument_id"
        :isLoading="is_loading"
        :instrument_id="instrument_id"
        :evaluation_criteria_micro_ids="evaluation_criteria_micro_ids"
        :allows_crud="allows_crud"
        :preview_evaluation="preview_evaluation"
        :checked_score="checked_score"
        :checked_weightning="checked_weightning"
        :evaluatee_view="evaluatee_view"
        :evaluator_view="evaluator_view"
        :is_running_test="is_running_test"
        :finished_test="finished_test"
        :user_id="user_id"
        :evaluation_situations="evaluation_situations"
        :closedEvaluationScore="closedEvaluationScore"
        :is_published="is_published"
      ></QuestionsContainer>
    </div>
  </div>
</template>

<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import draggable from "vuedraggable";

export default {
  name: "BodyInsrument",
  components: {
    draggable,
    QuestionsContainer: () => import("./Questions/QuestionsContainer"),
    // NewRichTextEditor: () => import("@/components/reusable/NewRichTextEditor"),
    ButtonMedium: () =>
      import("@/components/reusable/Buttons/Medium/ButtonMedium"),
    ContainerRichTextKlv3: () =>
      import("@/components/reusable/ContainerRichTextKlv3"),
    RenderVHtml: () => import("@/components/reusable/RenderVHtml"),
  },
  props: {
    instrument_id: {
      required: true,
      type: Number,
    },
    evaluation_criteria_micro_ids: {
      type: Array,
      required: true,
    },
    allows_crud: {
      type: Boolean,
      required: true,
    },
    preview_evaluation: {
      type: Boolean,
      required: true,
    },
    container_instrument_id: {
      type: String,
    },
    checked_score: {
      type: Boolean,
    },
    checked_weightning: {
      type: Boolean,
    },
    evaluatee_view: {
      type: Boolean,
      default: false,
    },
    evaluator_view: {
      type: Boolean,
      default: false,
    },
    is_running_test: {
      type: Boolean,
      default: false,
    },
    finished_test: {
      type: Boolean,
      default: false,
    },
    // para mostrar el resultado del evaluado al profesor.
    user_id: {
      type: Number,
      required: false,
    },
    // para restringir que el evaluador pueda colocar notas fuera del periodo actual con respecto al de la sección.
    closedEvaluationScore: {
      type: Boolean,
      default: false,
    },
    // Para que solo uno de los componentes pida las peticiones y el otro solo sirva para el imprimir todos los test en la misma línea.
    // y eso se ejecutaria solo si es !evaluatee_view && !evaluator_view
    requests_within_the_component: {
      type: Boolean,
      default: true,
    },
    evaluation_situations: {
      type: Array,
    },
    is_published: {
      type: Boolean,
    },
  },
  data() {
    return {
      is_loading: true,
      shuffledSegments: null,
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      test_segments: names.NEW_TEST_SEGMENTS,
      redaction_questions: names.NEW_REDACTION_QUESTIONS,
      multiple_choice_questions: names.NEW_MULTIPLE_CHOICE_QUESTIONS,
      filling_questions: names.NEW_FILLING_QUESTIONS,
      matching_questions: names.NEW_MATCHING_QUESTIONS,
      tests: names.NEW_TESTS,
    }),
    test() {
      return this.tests.find((x) => x.id == this.instrument_id);
    },
    evaluationSituation() {
      if (!this.test) return null;
      return this.evaluation_situations.find(
        (x) => x.id == this.test.evaluation_situation
      );
    },
    baseSegments() {
      return this.test_segments
        .filter((x) => x.test == this.instrument_id)
        .sort((a, b) => a.order - b.order);
    },
    shouldApplyRandomOrder() {
      // Condición: (preview_evaluation) || (evaluatee_view && is_running_test && !is_published)
      return (
        ((this.preview_evaluation && !this.evaluator_view) ||
          (this.evaluatee_view &&
            this.is_running_test &&
            !this.is_published)) &&
        this.test &&
        this.test.evaluatee_random_questions
      );
    },
    testSegments: {
      get() {
        if (this.shouldApplyRandomOrder) {
          return this.shuffledSegments || this.baseSegments;
        }
        return this.baseSegments;
      },
      set(list) {
        list.forEach((element, index) => {
          if (!isNaN(element.id)) {
            let payload = {
              new_test_segment_id: element.id,
              item: {
                order: index + 1,
              },
            };
            this.$store.dispatch(names.PATCH_NEW_TEST_SEGMENT, payload);
          }
        });
      },
    },
    questions() {
      let list = [];
      list = list.concat(
        this.redactionQuestions.map((question) => ({
          ...question,
          question_type: 1,
        }))
      );
      list = list.concat(
        this.multipleChoiceQuestions.map((question) => ({
          ...question,
          question_type: 2,
        }))
      );
      // list = list.concat(
      //   this.fillingQuestions.map((question) => ({
      //     ...question,
      //     question_type: 3,
      //   }))
      // );
      list = list.concat(
        this.matchingQuestions.map((question) => ({
          ...question,
          question_type: 4,
        }))
      );
      return list.sort((a, b) => a.order - b.order);
    },
    redactionQuestions() {
      return this.redaction_questions.filter(
        (x) => x.test == this.instrument_id
      );
    },
    multipleChoiceQuestions() {
      return this.multiple_choice_questions.filter(
        (x) => x.test == this.instrument_id
      );
    },
    fillingQuestions() {
      return this.filling_questions.filter((x) => x.test == this.instrument_id);
    },
    matchingQuestions() {
      return this.matching_questions.filter(
        (x) => x.test == this.instrument_id
      );
    },
    dragOptions() {
      return {
        animation: 0,
        group: "question",
        disabled: false,
        ghostClass: "ghost",
      };
    },
  },
  watch: {
    preview_evaluation(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.shuffledSegments = null;
      }
    },
    shouldApplyRandomOrder: {
      handler(newVal) {
        if (
          newVal &&
          !this.shuffledSegments &&
          this.baseSegments.length > 0
        ) {
          this.generateShuffledSegments();
          this.$nextTick(() => {
            this.$root.$emit("reinitialize-rich-text-components");
          });
        } else if (!newVal) {
          this.shuffledSegments = null;
        }
      },
      immediate: true,
    },
    // Regenera el shuffle cuando los segmentos llegan tarde del store (fetch
    // asíncrono) o cuando un remount del componente los vuelve a traer del
    // servidor con el orden original: al depender de baseSegments (derivado del
    // store) en vez de mutar segment.order directamente, un refetch nunca puede
    // "deshacer" el orden aleatorio que ya se le mostró al estudiante.
    baseSegments: {
      handler(newSegments, oldSegments) {
        if (this.shouldApplyRandomOrder && newSegments.length > 0) {
          if (
            !this.shuffledSegments ||
            (oldSegments && newSegments.length !== oldSegments.length)
          ) {
            this.$nextTick(() => {
              this.generateShuffledSegments();
            });
          }
        }
      },
      immediate: false,
    },
  },
  methods: {
    changeStateSegment(segment) {
      const payload = {
        new_test_segment_id: segment.id,
        item: {
          is_locked: !segment.is_locked,
        },
      };
      this.$store.dispatch(names.PATCH_NEW_TEST_SEGMENT, payload);
    },
    // filteredItems(segment) {
    //   return this.questions.filter((item) => item.segment == segment);
    // },
    showModalSegment(segment) {
      if (this.allows_crud && !segment.is_locked)
        this.$bvModal.show(
          `edit-title-segment-modal-${segment.id}-${this.instrument_id}-${this.container_instrument_id}`
        );
    },
    createSegment(text) {
      this.$store.dispatch(names.POST_NEW_TEST_SEGMENT, {
        title: text,
        order:
          this.testSegments.length > 0
            ? this.testSegments[this.testSegments.length - 1].order + 1
            : 1,
        test: this.instrument_id,
      });
    },
    // Modo lista: crea un segmento por línea, a continuación de los existentes
    createSegments(texts) {
      const last_order =
        this.testSegments.length > 0
          ? this.testSegments[this.testSegments.length - 1].order
          : 0;
      const items = texts.map((text, index) => ({
        title: text,
        order: last_order + index + 1,
        test: this.instrument_id,
      }));
      this.$store.dispatch(names.POST_NEW_TEST_SEGMENTS, items);
    },
    generateShuffledSegments() {
      const list = [...this.baseSegments];
      for (let i = list.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [list[i], list[j]] = [list[j], list[i]];
      }
      // Actualiza el order de copias locales; nunca muta los objetos del store
      const shuffledWithCorrectOrder = list.map((segment, index) => ({
        ...segment,
        order: index + 1,
      }));
      this.shuffledSegments = shuffledWithCorrectOrder;
    },
    patchSegmentTitle(segment, text) {
      const payload = {
        new_test_segment_id: segment.id,
        item: {
          title: text,
        },
      };
      this.$store.dispatch(names.PATCH_NEW_TEST_SEGMENT, payload);
    },
    askForDeleteSegment(segment_id) {
      this.$swal({
        title: `<p>${this.$t(
          "evaluations.newEvaluations.sureDeleteEntityAndQuestions",
          {
            entity: `<b>${this.$getVisibleNames(
              "evaluations2.testsegment",
              false,
              "Segmento"
            )}</b>`,
          }
        )}</p>`,
        text: this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
        showConfirmButton:
          this.questions.filter((x) => x.segment == segment_id).length != 0
            ? true
            : false,
        showCloseButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("evaluations.newEvaluations.deleteGroup2"),
        cancelButtonText:
          this.questions.filter((x) => x.segment == segment_id).length != 0
            ? `${this.$t(
                "evaluations.newEvaluations.only"
              )} ${this.$getVisibleNames(
                "evaluations2.testsegment",
                false,
                "Segmento"
              )}`
            : `${this.$t("reusable.common.delete")} ${this.$getVisibleNames(
                "evaluations2.testsegment",
                false,
                "Segmento"
              )}`,
      }).then((result) => {
        // Eliminar Conjunto
        if (result.value) {
          this.deleteSegmentGroup(segment_id);
        } else if (result.dismiss == "cancel") {
          this.$store.dispatch(names.DELETE_NEW_TEST_SEGMENT, segment_id);
        }
      });
    },
    async deleteSegmentGroup(segment_id) {
      for await (let redaction_question of this.redaction_questions.filter(
        (x) => x.test == this.instrument_id && x.segment == segment_id
      )) {
        await this.$store.dispatch(
          names.DELETE_NEW_REDACTION_QUESTION,
          redaction_question.id
        );
      }
      for await (let multiple_choice_question of this.multiple_choice_questions.filter(
        (x) => x.test == this.instrument_id && x.segment == segment_id
      )) {
        await this.$store.dispatch(
          names.DELETE_NEW_MULTIPLE_CHOICE_QUESTION,
          multiple_choice_question.id
        );
      }
      for await (let filling_question of this.filling_questions.filter(
        (x) => x.test == this.instrument_id && x.segment == segment_id
      )) {
        await this.$store.dispatch(
          names.DELETE_NEW_FILLING_QUESTION,
          filling_question.id
        );
      }
      for await (let matching_question of this.matching_questions.filter(
        (x) => x.test == this.instrument_id && x.segment == segment_id
      )) {
        await this.$store.dispatch(
          names.DELETE_NEW_MATCHING_QUESTION,
          matching_question.id
        );
      }
      await this.$store.dispatch(names.DELETE_NEW_TEST_SEGMENT, segment_id);
    },
    scrollToQuestion(payload) {
      let segmentRef =
        this.$refs[`segment-${payload.segment_id}-${this.instrument_id}`];
      if (payload.segment_id != null) segmentRef = segmentRef[0];
      if (segmentRef && typeof segmentRef.scrollIntoView === "function") {
        segmentRef.scrollIntoView(payload); // Llamar al método del hijo
      }
    },
    // Etiquetas de las preguntas tal como las ve el estudiante y en el orden en
    // que aparecen en pantalla. Con evaluatee_random_questions el orden aleatorio
    // solo existe en las copias locales (shuffledSegments y shuffledQuestions de
    // cada QuestionsContainer), el store conserva el orden original.
    getDisplayedQuestionLabels(questions) {
      const segment_positions = this.testSegments.map((x) => x.id);
      return questions
        .map((question) => {
          const displayed = this.findDisplayedQuestion(question) || question;
          const segment = this.testSegments.find(
            (x) => x.id == question.segment
          );
          const segment_position =
            question.segment == null
              ? segment_positions.length
              : segment_positions.indexOf(question.segment);
          return {
            segment_position,
            order: displayed.order,
            // Mismo formato que el número de NewQuestionCard.
            label: segment
              ? `${segment.order}.${displayed.order}`
              : `${displayed.order}`,
          };
        })
        .sort(
          (a, b) =>
            a.segment_position - b.segment_position || a.order - b.order
        )
        .map((x) => x.label);
    },
    findDisplayedQuestion(question) {
      const container_ref =
        this.$refs[`segment-${question.segment}-${this.instrument_id}`];
      const container = Array.isArray(container_ref)
        ? container_ref[0]
        : container_ref;
      if (!container || !container.questions) return null;
      return container.questions.find(
        (x) =>
          x.id == question.id && x.question_type == question.question_type
      );
    },
  },
  created() {
    if (
      (this.requests_within_the_component &&
        !this.evaluatee_view &&
        !this.evaluator_view) ||
      this.evaluatee_view ||
      this.evaluator_view
    ) {
      this.$store.dispatch(names.FETCH_NEW_TEST_SEGMENTS, {
        test_id: this.instrument_id,
      });
      this.$store.dispatch(names.FETCH_NEW_TEST_DESCRIPTORS, {
        test_id: this.instrument_id,
      });
      this.$store
        .dispatch(names.FETCH_NEW_REDACTION_QUESTIONS, {
          test_id: this.instrument_id,
        })
        .then(() => {
          this.$store
            .dispatch(names.FETCH_NEW_MULTIPLE_CHOICE_QUESTIONS, {
              test_id: this.instrument_id,
            })
            .then(() => {
              this.$store
                .dispatch(names.FETCH_NEW_FILLING_QUESTIONS, {
                  test_id: this.instrument_id,
                })
                .then(() => {
                  this.$store
                    .dispatch(names.FETCH_NEW_MATCHING_QUESTIONS, {
                      test_id: this.instrument_id,
                    })
                    .then(() => {
                      this.is_loading = false;
                      this.$emit("is_fetch_completed");
                    });
                });
            });
        });
    }
    if (
      !this.requests_within_the_component &&
      !this.evaluatee_view &&
      !this.evaluator_view
    )
      this.is_loading = false;
  },
};
</script>
<style scoped src="@/utils/rich_text_editor.css">
</style>
<style scoped>
.container-buttons-allow-cruds {
  display: flex;
  padding: 5px;
}
.unselectable-text {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.lock-btn {
  border: 1px;
  max-height: 30px;
  width: 27px;
}
.delete-btn {
  border: 1px;
  max-height: 30px;
  padding: 2px;
  width: 27px;
  transition: 0.3s all;
}
.delete-btn:hover {
  background-color: #e45d6b;
  transition: 0.3s all;
  transform: scale(1.1);
}
.container-buttons {
  display: flex;
  justify-content: left;
}
.title-top-segment {
  display: flex;
  margin-top: 4px;
  border-bottom: 1px solid var(--kl-border);
  min-height: 40px;
}
.title-segment {
  background: var(--kl-surface);
}
.segment-container {
  border-radius: var(--kl-radius-lg);
  margin: 10px 0px 0px 0px;
  padding: 5px;
  border: 1px solid var(--kl-border-soft);
  margin-bottom: 2em;
  overflow: hidden;
  background: var(--kl-surface-muted);
}
.segment-container-min-heigth {
  min-height: 60px;
}
.right-container-segment {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  page-break-before: auto;
  page-break-after: auto;
  page-break-inside: avoid;
}
.title-container:hover {
  background: var(--kl-surface-hover);
  cursor: pointer;
}
.move-icon {
  margin: auto;
  cursor: grab;
}
.question-move:hover {
  box-shadow: 0px 4px 12px -2px var(--secondary-color);
  background-color: var(--kl-color-accent-medium);
  color: var(--kl-text-on-primary);
}
.question-move {
  background: var(--kl-color-accent-medium);
  color: var(--kl-text-on-primary);
  /* height: 100%; */
  width: 25px;
  /* align-self: center; */
  display: flex;
}
.grabbable-cursor {
  cursor: grab;
  cursor: -moz-grab;
  cursor: -webkit-grab;
}
.grabbable-cursor:active {
  cursor: grabbing;
  cursor: -moz-grabbing;
  cursor: -webkit-grabbing;
}
.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
  background: var(--kl-color-accent-soft);
}
.only-impression-student {
  display: none !important;
}
@media print {
  .title-top-segment {
    border-bottom: none;
  }
  .only-impression-student {
    display: block !important;
  }
  .no-print-test {
    display: none !important;
  }
}
</style>
